import { render, staticRenderFns } from "./KnFinancialVarPromptPaymentDiscounts.vue?vue&type=template&id=609c0ba1"
import script from "./KnFinancialVarPromptPaymentDiscounts.js?vue&type=script&lang=js&external"
export * from "./KnFinancialVarPromptPaymentDiscounts.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports